module.exports = "/src/views/player/hudevo/ipad/components/fractions/elements/tasks/images/1.png";